import moment from 'moment';

const LOCALE = 'sr-Latn-RS';
const CURRENCY = 'RSD';

export function money(value) {
	return (value || 0.0).toLocaleString(LOCALE, {
		style: 'currency',
		currency: CURRENCY,
		useGrouping: false,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2 });
}

export function decimal(value) {
	return (value || 0.0).toLocaleString(LOCALE, {
		style: 'decimal',
		useGrouping: false,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2 });
}

export function date(value) {
	if (!value)
		return '';

	if (typeof value.toDate === 'function')
		return moment(value.toDate()).format('DD.MM.YYYY.');

	return moment(value).format('DD.MM.YYYY.');
}

export function fromNow(value) {
	if (!value)
		return '';

	return moment(value).locale(LOCALE).fromNow();
}



// WEBPACK FOOTER //
// ./src/filters/index.js